import { render, staticRenderFns } from "./RunningShopList.vue?vue&type=template&id=62533964"
import script from "./RunningShopList.vue?vue&type=script&lang=js"
export * from "./RunningShopList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports